<template>
  <div>
    <!-- <Navgar></Navgar> -->

    <div class="contact">
      <div class="contact-box">
        <p>您可以通过以下联系方式找到我们</p>
        <div class="contact-info">
          <img src="../assets/contact-wx.png" alt="Contact Information" />
          <img src="../assets/contact-gzh.png" alt="Contact Information" />
          <img src="../assets/contact-yx.png" alt="Contact Information" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navgar from "../components/Navgar/Navgar.vue";
export default {
  name: "Contact",
  components: {
    Navgar,
  },
  methods: {
    goServices() {
      console.log("华东");
      window.scrollTo({
        top: 1100,
        left: 0,
        behavior: "smooth",
      });
      // this.$router.push('/services');
    },
  },
};
</script>

<style scoped>
.contact-box {
  /* margin-top: -20vh; */
  /* padding-top: 30vh; */
  margin-bottom: 15vh;
}

.contact {
  margin-top: 15vh;

  background: url("../assets/youzhi_background.png") no-repeat center center;
  background-size: cover;
  height: 85vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #333;
  text-align: center;
  /* padding: 20px; */
}

.contact p {
  font-size: 24px;
}

.contact-info {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
}

.contact-info img {
  width: 30%;
  max-width: 200px;
  margin: 0 10px;
  height: auto;
  border-radius: 5px;
}

.arrow-container {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}

.arrow-container img {
  width: 30px;
  height: auto;
  cursor: pointer;
}
</style>
